// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "log/v1/log.proto" (package "log.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private logs RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { LogService } from "./log";
import type { GetRobotPartLogSourcesResponse } from "./log";
import type { GetRobotPartLogSourcesRequest } from "./log";
import type { GetRobotPartLogsResponse } from "./log";
import type { GetRobotPartLogsRequest } from "./log";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetLogsForMachinePartResourceResponse } from "./log";
import type { GetLogsForMachinePartResourceRequest } from "./log";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service log.v1.LogService
 */
export interface ILogServiceClient {
    /**
     * Get recent logs for a specified source
     *
     * @generated from protobuf rpc: GetLogsForMachinePartResource(log.v1.GetLogsForMachinePartResourceRequest) returns (log.v1.GetLogsForMachinePartResourceResponse);
     */
    getLogsForMachinePartResource(input: GetLogsForMachinePartResourceRequest, options?: RpcOptions): UnaryCall<GetLogsForMachinePartResourceRequest, GetLogsForMachinePartResourceResponse>;
    /**
     * @generated from protobuf rpc: GetRobotPartLogs(log.v1.GetRobotPartLogsRequest) returns (log.v1.GetRobotPartLogsResponse);
     */
    getRobotPartLogs(input: GetRobotPartLogsRequest, options?: RpcOptions): UnaryCall<GetRobotPartLogsRequest, GetRobotPartLogsResponse>;
    /**
     * Get the distinct logger names in a part's logs for a time range
     *
     * @generated from protobuf rpc: GetRobotPartLogSources(log.v1.GetRobotPartLogSourcesRequest) returns (log.v1.GetRobotPartLogSourcesResponse);
     */
    getRobotPartLogSources(input: GetRobotPartLogSourcesRequest, options?: RpcOptions): UnaryCall<GetRobotPartLogSourcesRequest, GetRobotPartLogSourcesResponse>;
}
/**
 * @generated from protobuf service log.v1.LogService
 */
export class LogServiceClient implements ILogServiceClient, ServiceInfo {
    typeName = LogService.typeName;
    methods = LogService.methods;
    options = LogService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get recent logs for a specified source
     *
     * @generated from protobuf rpc: GetLogsForMachinePartResource(log.v1.GetLogsForMachinePartResourceRequest) returns (log.v1.GetLogsForMachinePartResourceResponse);
     */
    getLogsForMachinePartResource(input: GetLogsForMachinePartResourceRequest, options?: RpcOptions): UnaryCall<GetLogsForMachinePartResourceRequest, GetLogsForMachinePartResourceResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLogsForMachinePartResourceRequest, GetLogsForMachinePartResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRobotPartLogs(log.v1.GetRobotPartLogsRequest) returns (log.v1.GetRobotPartLogsResponse);
     */
    getRobotPartLogs(input: GetRobotPartLogsRequest, options?: RpcOptions): UnaryCall<GetRobotPartLogsRequest, GetRobotPartLogsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartLogsRequest, GetRobotPartLogsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get the distinct logger names in a part's logs for a time range
     *
     * @generated from protobuf rpc: GetRobotPartLogSources(log.v1.GetRobotPartLogSourcesRequest) returns (log.v1.GetRobotPartLogSourcesResponse);
     */
    getRobotPartLogSources(input: GetRobotPartLogSourcesRequest, options?: RpcOptions): UnaryCall<GetRobotPartLogSourcesRequest, GetRobotPartLogSourcesResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartLogSourcesRequest, GetRobotPartLogSourcesResponse>("unary", this._transport, method, opt, input);
    }
}
